var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.heading)?_c('div',{staticClass:"bg-summersky text-white py-2 px-3"},[_c('h1',[_vm._v(_vm._s(_vm.heading))])]):_vm._e(),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }